// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/list_color_presets.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ColorPreset } from "./color_preset_pb";
import { file_vision_assets_v1_color_preset } from "./color_preset_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/list_color_presets.proto.
 */
export const file_vision_assets_v1_list_color_presets: GenFile = /*@__PURE__*/
  fileDesc("Cil2aXNpb24vYXNzZXRzL3YxL2xpc3RfY29sb3JfcHJlc2V0cy5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEibAoXTGlzdENvbG9yUHJlc2V0c1JlcXVlc3QSRwoGcGFyYW1zGAEgASgLMjcucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuTGlzdENvbG9yUHJlc2V0c1JlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyKlAQoYTGlzdENvbG9yUHJlc2V0c1Jlc3BvbnNlEkgKBnJlc3VsdBgBIAEoCzI4LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkxpc3RDb2xvclByZXNldHNSZXNwb25zZS5SZXN1bHQaPwoGUmVzdWx0EjUKB3ByZXNldHMYASADKAsyJC5wcm90b3MudmlzaW9uLmFzc2V0cy52MS5Db2xvclByZXNldGIGcHJvdG8z", [file_vision_assets_v1_color_preset]);

/**
 * @generated from message protos.vision.assets.v1.ListColorPresetsRequest
 */
export type ListColorPresetsRequest = Message<"protos.vision.assets.v1.ListColorPresetsRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListColorPresetsRequest.Params params = 1;
   */
  params?: ListColorPresetsRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListColorPresetsRequest.
 * Use `create(ListColorPresetsRequestSchema)` to create a new message.
 */
export const ListColorPresetsRequestSchema: GenMessage<ListColorPresetsRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_color_presets, 0);

/**
 * @generated from message protos.vision.assets.v1.ListColorPresetsRequest.Params
 */
export type ListColorPresetsRequest_Params = Message<"protos.vision.assets.v1.ListColorPresetsRequest.Params"> & {
};

/**
 * Describes the message protos.vision.assets.v1.ListColorPresetsRequest.Params.
 * Use `create(ListColorPresetsRequest_ParamsSchema)` to create a new message.
 */
export const ListColorPresetsRequest_ParamsSchema: GenMessage<ListColorPresetsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_color_presets, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.ListColorPresetsResponse
 */
export type ListColorPresetsResponse = Message<"protos.vision.assets.v1.ListColorPresetsResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ListColorPresetsResponse.Result result = 1;
   */
  result?: ListColorPresetsResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ListColorPresetsResponse.
 * Use `create(ListColorPresetsResponseSchema)` to create a new message.
 */
export const ListColorPresetsResponseSchema: GenMessage<ListColorPresetsResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_color_presets, 1);

/**
 * @generated from message protos.vision.assets.v1.ListColorPresetsResponse.Result
 */
export type ListColorPresetsResponse_Result = Message<"protos.vision.assets.v1.ListColorPresetsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.assets.v1.ColorPreset presets = 1;
   */
  presets: ColorPreset[];
};

/**
 * Describes the message protos.vision.assets.v1.ListColorPresetsResponse.Result.
 * Use `create(ListColorPresetsResponse_ResultSchema)` to create a new message.
 */
export const ListColorPresetsResponse_ResultSchema: GenMessage<ListColorPresetsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_list_color_presets, 1, 0);

